import { UsageEventProductMappingsService } from 'src/app/angularJS/services/usageEventProductMappings/usageEventProductMappings.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { VariantService } from 'src/app/angularJS/services/variant/variant.service';

export class CappedProductInfoBannerController {
  public static $inject = [
    'usageEventProductMappingsService',
    'QueryBuilder',
    'LinkBuilder',
    'variantService',
    '$scope'
  ];
  public usageEventProductMappingId: string;
  public productPurchaseDate: string;
  public usageEventProductMapping: InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMapping;
  public product: InterACT.Interfaces.Catalogues.Variant
  public replacedUsageEventProductMappings: Array<InterACT.Interfaces.UsageEventProductMappings.UsageEventProductMapping> = [];
  public events: {
    onUsageEventProductMappingIdUpdated: Function
  };

  constructor(
    private usageEventProductMappingsService: UsageEventProductMappingsService,
    private queryBuilder: QueryBuilder,
    private linkBuilder: LinkBuilder,
    private variantService: VariantService,
    private $scope) {
    // tslint:disable-next-line: forin
    for (const propertyName in this.$scope.vm) {
      this[propertyName] = this.$scope.vm[propertyName];
    }

    this.activate();
  }

  /**
 * A method that is called during controller isntantiation
 */
  public activate() {
    if (this.events) {
      this.events.onUsageEventProductMappingIdUpdated = (replacementUsageEventProductmappingId: string) => {
        this.onUsageEventProductMappingChanged(replacementUsageEventProductmappingId);
      };
    }

    this.getData();
  }

  /**
   * A method that gets the amount of money saved by paying for the parent product isntead of all of its child products individually
   */
  public getAmountOfMoneySaved = () => {
    if (!this.usageEventProductMapping) {
      return;
    }

    let totalForAllReplacedProducts = 0;

    this.replacedUsageEventProductMappings.forEach((replacedUsageEventProductMapping) => {
      totalForAllReplacedProducts += replacedUsageEventProductMapping.price;
    });

    return (totalForAllReplacedProducts - this.usageEventProductMapping.price) / 100;
  };

  /**
   * A method that gets the data required by this component
   */
  private getData() {
    this.getUsageEventProductMapping().then(() => {
      this.getCatalogueItemForUsageEventProductMapping(this.usageEventProductMapping.product.link).then((productVariant) => {
        this.product = productVariant;
      });
    });

    this.getReplacedUsageEventProductMappings();
  }

  /**
   * A method that handles the event where the usage event product mapping id used by this component has changed
   */
  private onUsageEventProductMappingChanged(replacementUsageEventProductmappingId: string) {
    this.usageEventProductMappingId = replacementUsageEventProductmappingId;
    this.getData();
  }

  /**
   * A method that gets the that usage event product mappings that were replaced by the one held on this component
   */
  private getReplacedUsageEventProductMappings() {
    const usageEventProductMappingLink = this.linkBuilder.getUsageEventProductMappingLink(this.usageEventProductMappingId);
    const query = this.queryBuilder.newParam().fieldIs('replacedBy.link', usageEventProductMappingLink).getParam();

    this.usageEventProductMappingsService.getList(1, 1000, query).then((response) => {
      this.replacedUsageEventProductMappings = response.usageEventProductMappings.map((usageEventProductMappingWithMeta) => {
        return usageEventProductMappingWithMeta.usageEventProductMapping;
      });
    });
  }

  /**
   * A method that gets the catalogue item for the supplied catalogue item id
   * @param link a link to the catalogue item to retrieve
   */
  private getCatalogueItemForUsageEventProductMapping(link: string) {
    const linkParts = link.split('/');
    const catalogueId = linkParts[2];
    const productId = linkParts[4];
    const variantIdWithQueryString = linkParts[6];
    const variantId = variantIdWithQueryString.indexOf('?') !== -1 ? variantIdWithQueryString.split('?')[0] : variantIdWithQueryString;

    return this.variantService.getVariant(catalogueId, parseInt(productId), parseInt(variantId)).then((productVariant) => {
      return productVariant;
    });
  }

  /**
   * A method that gets the parent usage event product mapping for the parentUsageEventProductMappingId state param
   */
  private getUsageEventProductMapping() {
    const query = this.queryBuilder.newParam().fieldIs('id', this.usageEventProductMappingId).getParam();

    return this.usageEventProductMappingsService.getList(1, 1, query).then((response) => {
      if (response.usageEventProductMappings.length > 0) {
        this.usageEventProductMapping = response.usageEventProductMappings[0].usageEventProductMapping;
        this.productPurchaseDate = <any>response.usageEventProductMappings[0].meta.created;
      }
    });
  }
}